import React, {Component, ReactElement, ReactNode} from 'react'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {CondominiumGroupData} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {UseFunctionMaster} from '../useFunctionMaster/repository/NatGetUseFunctionMaster'
import {NatPostCondominiumParams, RidgeInfo} from './repository/NatPostCondominium'
import PPImageInputWithPreview, {ImageInformation} from '../../../components/shared/forms/PPImageInputWithPreview'
import NatCondominiumRepo from './repository/NatCondominiumRepo'
import {
    ACCESS_CONTROL_MANAGER,
    ASSOC_ACCOUNTING_DEPT_CD,
    BILLING_DEADLINE,
    DATE_STRADDLE_RESERVATION_COUNTING_METHOD,
    FACILITY_RESERVATION_CONFIRMED_DATE,
    FACILITY_RESERVATION_DRAWING_END_DATE,
    FACILITY_RESERVATION_DRAWING_START_DATE,
    HAVE_OR_NOT,
    PREFECTURES_MASTER,
    RECEIVING_AGENCY_CD,
    TARGET_OR_NOT,
    USE_FUNCTION_ID,
    USER_DISPLAY_ITEMS,
    VALID_OR_NOT_CHECK,
} from '../../../CodeMaster'
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup'
import {
    LightGrayTableHead,
    RequiredChip,
    StyledTableCaption,
    TableFixed,
    TableRowName,
} from '../../../styledComponents/adminPage/Table'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {Messages} from '../../../Messages'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {AdminDefaultMediumButton, AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import PPInput from '../../../components/shared/forms/PPInput'
import {BackLink, DeleteLink, EditLink} from '../../../styledComponents/adminPage/Links'
import PPSelect, {OptionProps} from '../../../components/shared/forms/PPSelect'
import {addEmptyData, NoSelectedValue} from '../../../componentHelper/selectHelper'
import PPRadioGroup from '../../../components/shared/forms/PPRadioGroup'
import HintButton from '../../../components/shared/pageBaseComponents/HintButton'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {StyledDiv, StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {AdminPagePropsSet} from '../../../components/shared/hoc/createAdminPage'
import {Nullable, Optional} from '../../../app/TypeHelpers'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {cloneBean} from '../../common/util/Natutil'
import {formatForDateInput} from '../../../formatters/formatDate'
import {NatZipCode} from './repository/NatZipCode'
import {RequestItemError} from '../../../network/response/RequestItemError'
import {
    ChildUseFunctionInfo,
    CondominiumContactInfo,
    CondominiumData,
    RidgeInfo as GetRidgeInfo,
    UseFunctionInfo,
} from './repository/NatGetCondominium'
import {HKConstants} from '../../../HKConstants'
import {NatPutCondominiumParams} from './repository/NatPutCondominium'
import {Box, DialogContent, DialogTitle, Table, TableBody, TableCell, TableHead, TableRow,} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {AdminPageHeadingArea} from '../../../components/shared/pageBaseComponents/AdminPageHeadingArea'
import {createUUID, numberOrNull} from '../../../stringHelper/stringHelpers'
import {Colors, FontSizeInPixel} from '../../../styledComponents/Constants'
import PPErrorLabel from '../../../components/shared/forms/PPErrorLabel'
import {AdminDialog} from '../../../components/shared/pageBaseComponents/AdminDialog'
import {SelectChangeEvent} from '@mui/material/Select'

const DEFAULT_RIDGE_CD: string = '00'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'

interface Props {
    mode: 'register' | 'edit'
    condominium?: CondominiumData
    condominiumGroup: CondominiumGroupData
    useFunctionMaster: UseFunctionMaster[]
    condominiumRepo: NatCondominiumRepo
    eventEmitter: EventEmitterExAdmin
    onRegisterCondominium?: (condominium: NatPostCondominiumParams) => Promise<void>
    onEditCondominium?: (condominium: NatPutCondominiumParams) => Promise<void>
    backButtonText: string
    onBack: () => void
}

interface States {
    condominiumGroup: CondominiumGroupData
    useFunctionMaster: UseFunctionMaster[]
    registerParamCondominiumGroupId: number | null
    registerParamCondominiumCd: string
    registerParamCondominiumName: string
    registerParamRidgeInfos: RidgeInfo[]
    registerParamRidgeCd: string
    registerParamRidgeName: string
    registerParamZipcode: string
    registerParamCondominiumFileName: string
    registerParamCondominiumFileData: string
    registerParamPrefectureCd: string
    registerParamAddress2: string
    registerParamAddress3: string
    registerParamBusinessCenterSupport: string
    registerParamAccessControlManagerList: string[]
    registerParamUseFunctionInfo: UseFunctionInfo[]
    registerParamLotteryReserve: string
    registerParamFacilityReserveLotteryStart: string
    registerParamFacilityReserveLotteryEnd: string
    registerParamFacilityReserveConfirmLimit: string
    registerParamFacilityReserveLotteryMonth: number | null
    registerParamDateStraddleReservationCountingMethod: string
    registerParamBillingDeadline: string
    registerParamBoardUserDisplay: string
    registerParamReleaseStartDate: string
    registerParamReleaseEndDate: string
    registerParamContactMailAddress1: string
    registerParamContactMailAddress2: string
    selectedImagesInfo: ImageInformation[]
    condominiumGroupName: string
    defaultRidgeDeleteFlag: boolean
    registerParamAssocAccountingDeptCd: string
    registerParamReceivingAgencyCd: string
    showAssocDialog: boolean
    editAssocListIndex: number | null
    assocDialogMode: 'register' | 'edit'
    assocDialogAssocCd: string
    assocDialogAssocName: string
    assocList: CondominiumAssoc[]
    deleteAssocList: CondominiumAssoc[]
    assocIdUsingAssocFunction: string
    assocIdUsingApplyFunction: string
    condominiumAssocCdErrorMessage: string | null
    condominiumAssocNameErrorMessage: string | null
}

interface CondominiumAssoc {
    uid: string
    assocId: Nullable<number>
    assocCd: string
    assocName: string
    parentAssocUid: Nullable<string>
    parentAssocCd: Nullable<string>
    version: number
}

export class NatAdminCondominiumForm extends Component<Props, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)
        const {condominium, condominiumGroup, useFunctionMaster} = this.props

        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        let useFunctionInfo: UseFunctionInfo[]
        let assocList: CondominiumAssoc[] = []
        if (condominium) {
            const registeredUseFunctionInfo: UseFunctionInfo[] = condominium.useFunctionInfo
            useFunctionInfo = useFunctionMaster.map((master) => {
                const index: number = registeredUseFunctionInfo.findIndex(
                    registeredUseFunction => registeredUseFunction.functionId === master.useFunctionInfo.functionId)
                if (index !== -1) {
                    return ({
                        functionId: master.useFunctionInfo.functionId,
                        validFlag: registeredUseFunctionInfo[index].validFlag,
                        childUseFunctionInfo: registeredUseFunctionInfo[index].childUseFunctionInfo
                    })
                } else {
                    return ({
                        functionId: master.useFunctionInfo.functionId,
                        validFlag: VALID_OR_NOT_CHECK.NOT.value,
                        childUseFunctionInfo: master.childUseFunctionInfo.map(
                            (masterChildUseFunction) => {
                                return {
                                    functionId: masterChildUseFunction.functionId,
                                    validFlag: VALID_OR_NOT_CHECK.NOT.value
                                }
                            })
                    })
                }
            })
            assocList = condominium.assocList.map(assoc => ({
                uid: String(assoc.assocId),
                assocId: assoc.assocId,
                assocCd: assoc.assocCd,
                assocName: assoc.assocName,
                parentAssocUid: String(assoc.parentAssocId),
                parentAssocCd: condominium.assocList.find(a => a.assocId === assoc.parentAssocId)?.assocCd ?? null,
                version: assoc.version,
            }))
        } else {
            useFunctionInfo = useFunctionMaster.map((master) => {
                return {
                    functionId: master.useFunctionInfo.functionId,
                    validFlag: master.useFunctionInfo.validFlag,
                    childUseFunctionInfo: master.childUseFunctionInfo.map(
                        (masterChildUseFunction) => {
                            return {
                                functionId: masterChildUseFunction.functionId,
                                validFlag: masterChildUseFunction.validFlag
                            }
                        })
                }
            })
        }

        const defaultRidgeInfo: GetRidgeInfo | undefined = condominium?.ridgeInfo.find(
            (ridge) => ridge.ridgeCd === DEFAULT_RIDGE_CD)

        const selectedImagesInfo: ImageInformation[] = []
        if (condominium?.condominiumFileData) {
            selectedImagesInfo.push({
                fileNumber: null,
                url: condominium.condominiumFileData + '?'
                    + String(condominium.version),
                name: null,
                size: null,
                base64data: null,
                md5: null,
            })
        }

        this.state = {
            condominiumGroup: condominiumGroup,
            useFunctionMaster: useFunctionMaster,
            registerParamCondominiumGroupId: condominium?.condominiumGroupId ?? loginUserCondominiumGroupId,
            registerParamCondominiumCd: condominium?.condominiumCd ?? '',
            registerParamCondominiumName: condominium?.condominiumName ?? '',
            registerParamRidgeInfos: condominium?.ridgeInfo ?? [],
            registerParamRidgeCd: '',
            registerParamRidgeName: '',
            registerParamZipcode: condominium?.zipcode ?? '',
            registerParamCondominiumFileName: '',
            registerParamCondominiumFileData: condominium?.condominiumFileData ?? '',
            registerParamPrefectureCd: condominium?.prefectureCd ?? '',
            registerParamAddress2: condominium?.address2 ?? '',
            registerParamAddress3: condominium?.address3 ?? '',
            registerParamBusinessCenterSupport: condominium?.businessCenterSupport ?? TARGET_OR_NOT.NOT.value,
            registerParamAccessControlManagerList: condominium?.accessControlManagerList ?? [],
            registerParamUseFunctionInfo: useFunctionInfo,
            registerParamLotteryReserve: condominium?.lotteryReserve ?? HAVE_OR_NOT.NOT.value,
            registerParamFacilityReserveLotteryStart: condominium?.facilityReserveLotteryStart ?? '',
            registerParamFacilityReserveLotteryEnd: condominium?.facilityReserveLotteryEnd ?? '',
            registerParamFacilityReserveConfirmLimit: condominium?.facilityReserveConfirmLimit ?? '',
            registerParamFacilityReserveLotteryMonth: condominium?.facilityReserveLotteryMonth ?? null,
            registerParamDateStraddleReservationCountingMethod: condominium?.dateStraddleReservationCountingMethod ??
                DATE_STRADDLE_RESERVATION_COUNTING_METHOD.ONCE.value,
            registerParamBillingDeadline: condominium?.billingDeadline ?? BILLING_DEADLINE.VOL_15.value,
            registerParamBoardUserDisplay: condominium?.boardUserDisplay ?? '',
            registerParamReleaseStartDate: condominium?.releaseStartDate ?? '',
            registerParamReleaseEndDate: condominium?.releaseEndDate ?? '',
            registerParamContactMailAddress1: condominium?.condominiumContactInfo?.[0]?.mailAddress ?? '',
            registerParamContactMailAddress2: condominium?.condominiumContactInfo?.[1]?.mailAddress ?? '',
            selectedImagesInfo: selectedImagesInfo,
            condominiumGroupName: condominium?.condominiumGroupName ?? '',
            defaultRidgeDeleteFlag: !(defaultRidgeInfo &&
                defaultRidgeInfo.existsResidentUserFlg === HAVE_OR_NOT.HAVE.value),
            registerParamAssocAccountingDeptCd: condominium?.assocAccountingDeptCd ?? '',
            registerParamReceivingAgencyCd: condominium?.receivingAgencyCd ?? '',
            showAssocDialog: false,
            editAssocListIndex: null,
            assocDialogMode: 'register',
            assocDialogAssocCd: '',
            assocDialogAssocName: '',
            assocList: assocList,
            deleteAssocList: [],
            assocIdUsingAssocFunction: String(condominium?.assocIdUsingAssocFunction ?? ''),
            assocIdUsingApplyFunction: String(condominium?.assocIdUsingApplyFunction ?? ''),
            condominiumAssocCdErrorMessage: null,
            condominiumAssocNameErrorMessage: null,
        }

        this.onChangeCondominiumCd = this.onChangeCondominiumCd.bind(this)
        this.onChangeCondominiumName = this.onChangeCondominiumName.bind(this)
        this.onChangeRidgeCd = this.onChangeRidgeCd.bind(this)
        this.onChangeRidgeName = this.onChangeRidgeName.bind(this)
        this.onChangeZipCd = this.onChangeZipCd.bind(this)
        this.onChangePrefectureCd = this.onChangePrefectureCd.bind(this)
        this.onChangeAddress2 = this.onChangeAddress2.bind(this)
        this.onChangeAddress3 = this.onChangeAddress3.bind(this)
        this.onChangeBusinessCenterSupport = this.onChangeBusinessCenterSupport.bind(this)
        this.onChangeAccessControlManager = this.onChangeAccessControlManager.bind(this)
        this.onChangeValidFlag = this.onChangeValidFlag.bind(this)
        this.onChangeChildValidFlag = this.onChangeChildValidFlag.bind(this)
        this.onChangeLotteryReserve = this.onChangeLotteryReserve.bind(this)
        this.onChangeFacilityReserveLotteryStart = this.onChangeFacilityReserveLotteryStart.bind(this)
        this.onChangeFacilityReserveLotteryEnd = this.onChangeFacilityReserveLotteryEnd.bind(this)
        this.onChangeFacilityReserveConfirmLimit = this.onChangeFacilityReserveConfirmLimit.bind(this)
        this.onChangeFacilityReserveLotteryMonth = this.onChangeFacilityReserveLotteryMonth.bind(this)
        this.onChangeDateStraddleReservationCountingMethod =
            this.onChangeDateStraddleReservationCountingMethod.bind(this)
        this.onChangeBillingDeadline = this.onChangeBillingDeadline.bind(this)
        this.onChangeBoardUserDisplay = this.onChangeBoardUserDisplay.bind(this)
        this.onChangeReleaseStartDate = this.onChangeReleaseStartDate.bind(this)
        this.onChangeReleaseEndDate = this.onChangeReleaseEndDate.bind(this)
        this.getAddressFromZipcode = this.getAddressFromZipcode.bind(this)
        this.addRidgeInfo = this.addRidgeInfo.bind(this)
        this.delRidgeInfo = this.delRidgeInfo.bind(this)
        this.handleImagesChange = this.handleImagesChange.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.onChangeAssocAccountingDeptCd = this.onChangeAssocAccountingDeptCd.bind(this)
        this.onChangeReceivingAgencyCd = this.onChangeReceivingAgencyCd.bind(this)
        this.onClickRegisterButton = this.onClickRegisterButton.bind(this)
        this.handleClickAddAssoc = this.handleClickAddAssoc.bind(this)
        this.handleClickAssocDialogCancelButton = this.handleClickAssocDialogCancelButton.bind(this)
        this.handleClickAssocDialogResisterButton = this.handleClickAssocDialogResisterButton.bind(this)
        this.onChangeAssocCd = this.onChangeAssocCd.bind(this)
        this.onChangeAssocName = this.onChangeAssocName.bind(this)
        this.onChangeParentAssoc = this.onChangeParentAssoc.bind(this)
        this.onChangeAssocIdUsingAssocFunction = this.onChangeAssocIdUsingAssocFunction.bind(this)
        this.onChangeAssocIdUsingApplyFunction = this.onChangeAssocIdUsingApplyFunction.bind(this)
        this.assocListDeleteLinkClick = this.assocListDeleteLinkClick.bind(this)
    }

    async onClickRegisterButton(): Promise<void> {
        let condominiumFileName: string = ''
        let condominiumFileData: string = ''
        if (this.state.selectedImagesInfo.length > 0) {
            this.state.selectedImagesInfo.some((selectedImage) => {
                condominiumFileName = selectedImage.name as string
                condominiumFileData = selectedImage.base64data as string
                return true
            })
        }

        const condominiumContactInfo: CondominiumContactInfo[] = []
        condominiumContactInfo.push({mailAddress: this.state.registerParamContactMailAddress1})
        condominiumContactInfo.push({mailAddress: this.state.registerParamContactMailAddress2})

        let facilityReserveLotteryMonth: Optional<number>
        let facilityReserveFasterPeriod: Optional<number>
        if (this.state.registerParamFacilityReserveLotteryMonth) {
            facilityReserveLotteryMonth =
                this.state.registerParamFacilityReserveLotteryMonth
            facilityReserveFasterPeriod =
                Number(this.state.registerParamFacilityReserveLotteryMonth) +
                Number(HKConstants.CMN.OPC.BIAS_PERIOD_FASTCOME_FASTSERVE)
        }

        const dateStraddleReservationCountingMethod: string =
            isReserveFacilityAvailable(this.state.registerParamUseFunctionInfo)
                ? this.state.registerParamDateStraddleReservationCountingMethod
                : DATE_STRADDLE_RESERVATION_COUNTING_METHOD.ONCE.value

        let receivingAgencyCd: Optional<string>
        let assocAccountingDeptCd: Optional<string>
        if (isAccountTransferAvailable(this.state.registerParamUseFunctionInfo)) {
            receivingAgencyCd = this.state.registerParamReceivingAgencyCd
            assocAccountingDeptCd = this.state.registerParamAssocAccountingDeptCd
        }

        let assocCdUsingAssocFunction: string = ''
        if (this.state.assocIdUsingAssocFunction) {
            const condominiumAssoc = this.state.assocList.find(
                assoc => this.state.assocIdUsingAssocFunction === assoc.uid
            )
            if (condominiumAssoc) {
                assocCdUsingAssocFunction = condominiumAssoc.assocCd
            } else {
                throw Error('選択された管理組合が管理組合リストにない')
            }
        }
        let assocCdUsingApplyFunction: string = ''
        if (this.state.assocIdUsingApplyFunction) {
            const condominiumAssoc = this.state.assocList.find(
                assoc => this.state.assocIdUsingApplyFunction === assoc.uid
            )
            if (condominiumAssoc) {
                assocCdUsingApplyFunction = condominiumAssoc.assocCd
            } else {
                throw Error('選択された管理組合が管理組合リストにない')
            }
        }

        if (this.props.onRegisterCondominium) {
            const requestRegisterAssocList = this.state.assocList.map(assoc => ({
                assocCd: assoc.assocCd,
                assocName: assoc.assocName,
                parentAssocCd: this.state.assocList.find(a => a.uid === assoc.parentAssocUid)?.assocCd ?? null
            }))

            const registerCondominiumParams: NatPostCondominiumParams = {
                condominiumCd: this.state.registerParamCondominiumCd,
                condominiumName: this.state.registerParamCondominiumName,
                ridgeInfo: this.state.registerParamRidgeInfos.length > 0 ? this.state.registerParamRidgeInfos
                    : [{ridgeCd: DEFAULT_RIDGE_CD, ridgeName: ''}],
                condominiumFileName: condominiumFileName,
                condominiumFileData: condominiumFileData,
                zipcode: this.state.registerParamZipcode,
                prefectureCd: this.state.registerParamPrefectureCd,
                address2: this.state.registerParamAddress2,
                address3: this.state.registerParamAddress3,
                businessCenterSupport: this.state.registerParamBusinessCenterSupport,
                accessControlManagerList: this.state.registerParamAccessControlManagerList,
                useFunctionInfo: this.state.registerParamUseFunctionInfo,
                assocList: requestRegisterAssocList,
                assocCdUsingAssocFunction: assocCdUsingAssocFunction,
                assocCdUsingApplyFunction: assocCdUsingApplyFunction,
                lotteryReserve: this.state.registerParamLotteryReserve,
                facilityReserveLotteryStart: this.state.registerParamFacilityReserveLotteryStart,
                facilityReserveLotteryEnd: this.state.registerParamFacilityReserveLotteryEnd,
                facilityReserveConfirmLimit: this.state.registerParamFacilityReserveConfirmLimit,
                facilityReserveLotteryMonth: facilityReserveLotteryMonth,
                facilityReserveFasterPeriod: facilityReserveFasterPeriod,
                dateStraddleReservationCountingMethod: dateStraddleReservationCountingMethod,
                receivingAgencyCd: receivingAgencyCd,
                assocAccountingDeptCd: assocAccountingDeptCd,
                billingDeadline: this.state.registerParamBillingDeadline,
                boardUserDisplay: this.state.registerParamBoardUserDisplay,
                releaseStartDate: this.state.registerParamReleaseStartDate,
                releaseEndDate: this.state.registerParamReleaseEndDate,
                condominiumContactInfo: condominiumContactInfo,
            }
            if (this.state.registerParamCondominiumGroupId) {
                registerCondominiumParams.condominiumGroupId = this.state.registerParamCondominiumGroupId
            }

            await this.props.onRegisterCondominium(registerCondominiumParams)
        }

        if (this.props.onEditCondominium) {
            const requestUpdateAssocList = this.state.assocList.map(assoc => ({
                assocId: assoc.assocId,
                assocCd: assoc.assocCd,
                assocName: assoc.assocName,
                parentAssocId: this.state.assocList.find(a => a.uid === assoc.parentAssocUid)?.assocId ?? null,
                parentAssocCd: this.state.assocList.find(a => a.uid === assoc.parentAssocUid)?.assocCd ?? null,
                version: assoc.version,
            }))

            const requestDeleteAssocList = this.state.deleteAssocList.map(assoc => ({
                assocId: assoc.assocId,
                assocCd: assoc.assocCd,
                assocName: assoc.assocName,
                parentAssocId: this.state.assocList.find(a => a.uid === assoc.parentAssocUid)?.assocId ?? null,
                parentAssocCd: this.state.assocList.find(a => a.uid === assoc.parentAssocUid)?.assocCd ?? null,
                version: assoc.version,
            }))

            const registerCondominiumParams: NatPutCondominiumParams = {
                condominiumCd: this.state.registerParamCondominiumCd,
                condominiumGroupId: this.state.registerParamCondominiumGroupId ?? 0,
                condominiumName: this.state.registerParamCondominiumName,
                ridgeInfo: this.state.registerParamRidgeInfos,
                condominiumFileName: condominiumFileName,
                condominiumFileData: condominiumFileData,
                condominiumFileDeleteFlag: this.state.selectedImagesInfo.length === 0 ? '1' : '0',
                zipcode: this.state.registerParamZipcode,
                prefectureCd: this.state.registerParamPrefectureCd,
                address2: this.state.registerParamAddress2,
                address3: this.state.registerParamAddress3,
                businessCenterSupport: this.state.registerParamBusinessCenterSupport,
                accessControlManagerList: this.state.registerParamAccessControlManagerList,
                useFunctionInfo: this.state.registerParamUseFunctionInfo,
                assocList: requestUpdateAssocList,
                deleteAssocList: requestDeleteAssocList,
                assocCdUsingAssocFunction: assocCdUsingAssocFunction,
                assocCdUsingApplyFunction: assocCdUsingApplyFunction,
                lotteryReserve: this.state.registerParamLotteryReserve,
                facilityReserveLotteryStart: this.state.registerParamFacilityReserveLotteryStart,
                facilityReserveLotteryEnd: this.state.registerParamFacilityReserveLotteryEnd,
                facilityReserveConfirmLimit: this.state.registerParamFacilityReserveConfirmLimit,
                facilityReserveLotteryMonth: facilityReserveLotteryMonth,
                facilityReserveFasterPeriod: facilityReserveFasterPeriod,
                dateStraddleReservationCountingMethod: dateStraddleReservationCountingMethod,
                receivingAgencyCd: receivingAgencyCd,
                assocAccountingDeptCd: assocAccountingDeptCd,
                billingDeadline: this.state.registerParamBillingDeadline,
                boardUserDisplay: this.state.registerParamBoardUserDisplay,
                releaseStartDate: this.state.registerParamReleaseStartDate,
                releaseEndDate: this.state.registerParamReleaseEndDate,
                condominiumContactInfo: condominiumContactInfo,
                version: this.props.condominium?.version ?? 0,
            }

            await this.props.onEditCondominium(registerCondominiumParams)
        }
    }

    judgeRegisterButtonDisabled(): boolean {
        return judgeRegisterButtonDisabledFunction(
            this.props.mode,
            this.state.registerParamCondominiumGroupId,
            this.state.registerParamCondominiumCd,
            this.state.registerParamCondominiumName,
            this.state.registerParamRidgeInfos,
            this.state.registerParamZipcode,
            this.state.registerParamPrefectureCd,
            this.state.registerParamAddress2,
            this.state.registerParamBusinessCenterSupport,
            this.state.registerParamUseFunctionInfo,
            this.state.assocList,
            this.state.assocIdUsingAssocFunction,
            this.state.assocIdUsingApplyFunction,
            this.state.registerParamLotteryReserve,
            this.state.registerParamFacilityReserveLotteryStart,
            this.state.registerParamFacilityReserveLotteryEnd,
            this.state.registerParamFacilityReserveLotteryMonth,
            this.state.registerParamDateStraddleReservationCountingMethod,
            this.state.registerParamBoardUserDisplay,
            this.state.registerParamAssocAccountingDeptCd,
            this.state.registerParamReceivingAgencyCd,
            this.state.registerParamBillingDeadline,
        )
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        this.setState({registerParamCondominiumGroupId: condomoniumGroupId})
    }

    onChangeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamCondominiumCd: event.target.value})
    }

    onChangeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamCondominiumName: event.target.value})
    }

    onChangeRidgeCd(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamRidgeCd: event.target.value})
    }

    onChangeRidgeName(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamRidgeName: event.target.value})
    }

    onChangeZipCd(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamZipcode: event.target.value})
    }

    onChangePrefectureCd(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamPrefectureCd: ''})
        } else {
            const codeMaster = PREFECTURES_MASTER.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                this.setState({registerParamPrefectureCd: event.target.value as string})
            } else {
                this.setState({registerParamPrefectureCd: ''})
            }
        }
    }

    onChangeAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamAddress2: event.target.value})
    }

    onChangeAddress3(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({registerParamAddress3: event.target.value})
    }

    onChangeContactMailAddress = (index: number) => (event: React.ChangeEvent<HTMLInputElement>) => {
        if (index === 1) {
            this.setState({registerParamContactMailAddress1: event.target.value})
        } else if (index === 2) {
            this.setState({registerParamContactMailAddress2: event.target.value})
        }
    }

    onChangeBusinessCenterSupport(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({registerParamBusinessCenterSupport: event.target.value as string})
    }

    onChangeAccessControlManager(label: string, checked: boolean): void {
        const checkedAccessControlManager = ACCESS_CONTROL_MANAGER.values()
            .find(accessControlManager => accessControlManager.label === label)
        if (!checkedAccessControlManager) {
            return
        }
        const managerSet = new Set(this.state.registerParamAccessControlManagerList)
        if (checked) {
            managerSet.add(checkedAccessControlManager.value)
        } else {
            managerSet.delete(checkedAccessControlManager.value)
        }
        this.setState({registerParamAccessControlManagerList: [...managerSet]})
    }

    onChangeValidFlag(functionId: number): void {
        const registerParamUseFunctionInfo = cloneBean(this.state.registerParamUseFunctionInfo)
        let {assocIdUsingAssocFunction} = this.state
        registerParamUseFunctionInfo.forEach((registerUseFunction) => {
            if (registerUseFunction.functionId === functionId) {
                if (registerUseFunction.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                    registerUseFunction.validFlag = VALID_OR_NOT_CHECK.VALID.value
                } else {
                    registerUseFunction.validFlag = VALID_OR_NOT_CHECK.NOT.value
                    if (functionId === Number(USE_FUNCTION_ID.ASSOC_DIRECTOR.value)) {
                        assocIdUsingAssocFunction = ''
                    }
                }
            }
        })
        this.setState({
            registerParamUseFunctionInfo: registerParamUseFunctionInfo,
            assocIdUsingAssocFunction: assocIdUsingAssocFunction
        })
    }

    onChangeChildValidFlag(functionId: number, childFunctionId: number): void {
        const registerParamUseFunctionInfo = cloneBean(this.state.registerParamUseFunctionInfo)
        const registerParentUseFunctionInfo = registerParamUseFunctionInfo
            .find(registerUseFunction => registerUseFunction.functionId === functionId)

        if (!registerParentUseFunctionInfo) {
            return
        }

        registerParentUseFunctionInfo.childUseFunctionInfo.forEach((registerChildUseFunction) => {
            if (registerChildUseFunction.functionId === childFunctionId) {
                if (registerChildUseFunction.validFlag === VALID_OR_NOT_CHECK.NOT.value) {
                    registerChildUseFunction.validFlag = VALID_OR_NOT_CHECK.VALID.value
                } else {
                    registerChildUseFunction.validFlag = VALID_OR_NOT_CHECK.NOT.value
                }
            }
        })

        const childAllInvalid = registerParentUseFunctionInfo.childUseFunctionInfo
            .every(registerChildUseFunction => registerChildUseFunction.validFlag === VALID_OR_NOT_CHECK.NOT.value)
        if (childAllInvalid) {
            registerParentUseFunctionInfo.validFlag = VALID_OR_NOT_CHECK.NOT.value
        }

        const childAnyValid = registerParentUseFunctionInfo.childUseFunctionInfo
            .some(registerChildUseFunction => registerChildUseFunction.validFlag === VALID_OR_NOT_CHECK.VALID.value)
        if (childAnyValid) {
            registerParentUseFunctionInfo.validFlag = VALID_OR_NOT_CHECK.VALID.value
        }

        let {assocIdUsingApplyFunction} = this.state
        if (!isApplyFunctionAvailable(registerParamUseFunctionInfo)) {
            assocIdUsingApplyFunction = ''
        }

        this.setState({
            registerParamUseFunctionInfo: registerParamUseFunctionInfo,
            assocIdUsingApplyFunction: assocIdUsingApplyFunction
        })
    }

    onChangeLotteryReserve(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({registerParamLotteryReserve: event.target.value as string})

        if (event.target.value as string === HAVE_OR_NOT.HAVE.value) {
            this.setState({
                registerParamFacilityReserveLotteryMonth: 1,
                // 【仕様変更】施設予約抽選期間の開始をラベルで1固定に変更 ADD
                registerParamFacilityReserveLotteryStart: FACILITY_RESERVATION_DRAWING_START_DATE.VOL_1.value,
            })
        } else {
            this.setState({
                registerParamFacilityReserveLotteryStart: '',
                registerParamFacilityReserveLotteryEnd: '',
                registerParamFacilityReserveConfirmLimit: '',
                registerParamFacilityReserveLotteryMonth: null,
            })
        }
    }

    onChangeFacilityReserveLotteryStart(event: React.ChangeEvent<{ value: unknown }>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamFacilityReserveLotteryStart: ''})
        } else {
            const codeMaster =
                FACILITY_RESERVATION_DRAWING_START_DATE.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                this.setState({registerParamFacilityReserveLotteryStart: event.target.value as string})
            } else {
                this.setState({registerParamFacilityReserveLotteryStart: ''})
            }
        }
    }

    onChangeFacilityReserveLotteryEnd(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamFacilityReserveLotteryEnd: ''})
        } else {
            const codeMaster = FACILITY_RESERVATION_DRAWING_END_DATE.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                this.setState({registerParamFacilityReserveLotteryEnd: event.target.value as string})
            } else {
                this.setState({registerParamFacilityReserveLotteryEnd: ''})
            }
        }
    }

    onChangeFacilityReserveConfirmLimit(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamFacilityReserveConfirmLimit: ''})
        } else {
            this.setState({registerParamFacilityReserveConfirmLimit: event.target.value as string})
        }
    }

    onChangeFacilityReserveLotteryMonth(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({registerParamFacilityReserveLotteryMonth: event.target.value as number})
    }

    onChangeBillingDeadline(event: SelectChangeEvent<unknown>): void {
        const codeMaster = BILLING_DEADLINE.codeToEnumConstants(event.target.value as string)
        if (codeMaster) {
            this.setState({registerParamBillingDeadline: event.target.value as string})
        } else {
            this.setState({registerParamBillingDeadline: ''})
        }
    }

    onChangeBoardUserDisplay(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamBoardUserDisplay: ''})
        } else {
            this.setState({registerParamBoardUserDisplay: event.target.value as string})
        }
    }

    onChangeReleaseStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({registerParamReleaseStartDate: formatForDateInput(date.toString())})
        } else {
            this.setState({registerParamReleaseStartDate: ''})
        }
    }

    onChangeReleaseEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({registerParamReleaseEndDate: formatForDateInput(date.toString())})
        } else {
            this.setState({registerParamReleaseEndDate: ''})
        }
    }

    onChangeDateStraddleReservationCountingMethod(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({registerParamDateStraddleReservationCountingMethod: event.target.value as string})
    }

    onChangeAssocAccountingDeptCd(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamAssocAccountingDeptCd: ''})
        } else {
            this.setState({registerParamAssocAccountingDeptCd: event.target.value as string})
        }
    }

    onChangeReceivingAgencyCd(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({registerParamReceivingAgencyCd: ''})
        } else {
            this.setState({registerParamReceivingAgencyCd: event.target.value as string})
        }
    }

    onChangeAssocCd(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({
            assocDialogAssocCd: event.target.value as string,
            condominiumAssocCdErrorMessage: null,
        })
    }

    onChangeAssocName(event: React.ChangeEvent<{ value: unknown }>): void {
        this.setState({
            assocDialogAssocName: event.target.value as string,
            condominiumAssocNameErrorMessage: null,
        })
    }

    onChangeParentAssoc(event: SelectChangeEvent<unknown>): void {
        const parentAssocUid = event.target.value !== NoSelectedValue ? event.target.value as string : null
        const parentAssocCd: string | null =
            parentAssocUid == null ? null : this.state.assocList.find(a => a.uid === parentAssocUid)?.assocCd ?? null;

        this.setState(prev => ({
            assocList: prev.assocList
                .map(a => a.uid === event.target.name ? {...a, parentAssocUid, parentAssocCd} : a),
        }))
    }

    onChangeAssocIdUsingAssocFunction(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({assocIdUsingAssocFunction: ''})
        } else {
            this.setState({assocIdUsingAssocFunction: event.target.value as string})
        }
    }

    onChangeAssocIdUsingApplyFunction(event: SelectChangeEvent<unknown>): void {
        if (event.target.value === NoSelectedValue) {
            this.setState({assocIdUsingApplyFunction: ''})
        } else {
            this.setState({assocIdUsingApplyFunction: event.target.value as string})
        }
    }

    assocListDeleteLinkClick = (index: number) => () => {
        const {assocList, deleteAssocList} = this.state
        let {assocIdUsingAssocFunction, assocIdUsingApplyFunction} = this.state
        const deleteAssoc: CondominiumAssoc = assocList[index]
        assocList.splice(index, 1)
        if (assocIdUsingAssocFunction === deleteAssoc.uid) {
            assocIdUsingAssocFunction = ''
        }
        if (assocIdUsingApplyFunction === deleteAssoc.uid) {
            assocIdUsingApplyFunction = ''
        }
        if (deleteAssoc.version > 0) {
            deleteAssocList.push(deleteAssoc)
        }
        this.setState({
            assocList: assocList,
            deleteAssocList: deleteAssocList,
            assocIdUsingAssocFunction: assocIdUsingAssocFunction,
            assocIdUsingApplyFunction: assocIdUsingApplyFunction
        })
    }

    addRidgeInfo(ridgeInfo: RidgeInfo): void {
        const ridgeInfos = this.state.registerParamRidgeInfos
        if (ridgeInfos[0] && !ridgeInfos[0].ridgeName && ridgeInfos[0].ridgeCd === DEFAULT_RIDGE_CD &&
            this.state.defaultRidgeDeleteFlag) {
            // 登録時に棟を追加しなかった物件は 棟コード「00」 棟名「」で登録されている為、削除する
            ridgeInfos.shift()
        }
        ridgeInfos.push(ridgeInfo)
        this.setState({
            registerParamRidgeInfos: ridgeInfos,
            registerParamRidgeCd: '',
            registerParamRidgeName: '',
        })
    }

    delRidgeInfo(index: number): void {
        const registerParamRidgeInfos = this.state.registerParamRidgeInfos
        registerParamRidgeInfos.splice(index, 1)
        this.setState({registerParamRidgeInfos: registerParamRidgeInfos})
    }

    handleClickAddAssoc(): void {
        this.setState({
            showAssocDialog: true,
            assocDialogMode: 'register',
        })
    }

    handleClickEditAssoc = (index: number) => () => {
        const {
            assocList,
        } = this.state

        this.setState({
            showAssocDialog: true,
            editAssocListIndex: index,
            assocDialogMode: 'edit',
            assocDialogAssocCd: assocList[index].assocCd,
            assocDialogAssocName: assocList[index].assocName,
        })
    }

    private closeAssocDialog(): void {
        this.setState({
            showAssocDialog: false,
            editAssocListIndex: null,
            assocDialogAssocCd: '',
            assocDialogAssocName: '',
            condominiumAssocCdErrorMessage: '',
            condominiumAssocNameErrorMessage: '',
        })
    }

    handleClickAssocDialogCancelButton(): void {
        this.closeAssocDialog()
    }

    isDuplicatedAssocCd(assocCd: string, assocList: CondominiumAssoc[]): boolean {
        if (assocList.length === 0) {
            return false
        }

        if (assocList.filter(assoc => assoc.assocCd === assocCd)
            .length === 0) {
            return false
        }
        return true
    }

    isDuplicatedAssocName(assocName: string, assocList: CondominiumAssoc[]): boolean {
        if (assocList.length === 0) {
            return false
        }

        if (assocList.filter(assoc => assoc.assocName === assocName)
            .length === 0) {
            return false
        }
        return true
    }

    handleClickAssocDialogResisterButton(): void {
        const {
            assocList,
            editAssocListIndex,
            assocDialogMode,
            assocDialogAssocCd,
            assocDialogAssocName,
        } = this.state

        let errorOccurred: boolean = false

        if (!assocDialogAssocCd.match(/^[0-9]*$/)) {
            this.setState({
                condominiumAssocCdErrorMessage: Messages.EOPCC1009.toString('半角数字'),
            })
            errorOccurred = true
        }
        const assocListWithoutEditAssoc =
            assocList.filter((assoc, index) => index !== editAssocListIndex)
        if (this.isDuplicatedAssocCd(assocDialogAssocCd, assocListWithoutEditAssoc)) {
            this.setState({
                condominiumAssocCdErrorMessage: Messages.EOPCC1013.toString(this.state.assocDialogAssocCd, '組合コード'),
            })
            errorOccurred = true
        }
        if (this.isDuplicatedAssocName(assocDialogAssocName, assocListWithoutEditAssoc)) {
            this.setState({
                condominiumAssocNameErrorMessage: Messages.EOPCC1028.toString('組合名'),
            })
            errorOccurred = true
        }

        if (errorOccurred) {
            return
        }

        if (assocDialogMode === 'register') {
            const condominiumAssoc: CondominiumAssoc = {
                uid: createUUID(),
                assocId: null,
                assocCd: assocDialogAssocCd,
                assocName: assocDialogAssocName,
                parentAssocUid: null,
                parentAssocCd: null,
                version: 0,
            }
            assocList.push(condominiumAssoc)
        } else {
            const updateAssocList = assocList.map((assoc, index) => {
                if (index === editAssocListIndex) {
                    return {
                        ...assoc,
                        assocCd: assocDialogAssocCd,
                        assocName: assocDialogAssocName,
                    }
                } else {
                    return assoc
                }
            })
            this.setState({
                assocList: updateAssocList,
            })
        }

        this.closeAssocDialog()
    }

    handleImagesChange(images: ImageInformation[]): void {
        this.setState({
            selectedImagesInfo: images,
        })
    }

    async getAddressFromZipcode(zipCode: string): Promise<void> {

        await this.props.eventEmitter.showLoading()
        try {
            // 桁数不正の場合、単純に結果が取得できないので特に事前チェックは行わない
            const firstPart = zipCode.substr(0, 3)
            const lastPart = zipCode.substr(3, zipCode.length - 1)

            await this.props.condominiumRepo.getZipCode(firstPart, lastPart).then(
                zipData => {
                    const zipCodeResponse: NatZipCode = zipData

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data[0] && zipCodeResponse.data[0].ja) {

                        // 取得した住所情報を反映
                        this.setState({
                            registerParamZipcode: zipCode,
                            registerParamPrefectureCd: zipCodeResponse.data[0].prefcode,
                            registerParamAddress2: zipCodeResponse.data[0].ja.address1,
                            registerParamAddress3: zipCodeResponse.data[0].ja.address2,
                        })
                    }

                    if (zipCodeResponse && zipCodeResponse.data
                        && zipCodeResponse.data.length > 1) {
                        // 郵便番号から取得できた住所が複数存在する場合
                        const requestItemError = new RequestItemError(
                            'zipcode', Messages.WCONA0002.toString(), 'WCONA0002')
                        this.props.eventEmitter.emit(requestItemError.resultCode, requestItemError)
                    }
                },
            ).catch(
                e => {
                    // 郵便番号から住所が取得できなかった場合
                    const requestItemError = new RequestItemError(
                        'zipcode', Messages.ECONA0001.toString(), 'ECONA0001')
                    this.props.eventEmitter.emit(requestItemError.resultCode, requestItemError)
                },
            )
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    judgeUseFunctionValidFlag(functionId: number): boolean {
        if (!this.state.registerParamUseFunctionInfo) {
            return false
        }
        return this.state.registerParamUseFunctionInfo.some((registerUseFunction) => {
            return registerUseFunction.functionId === functionId &&
                registerUseFunction.validFlag === VALID_OR_NOT_CHECK.VALID.value
        })
    }

    judgeChildFunctionValidFlag(functionId: number, childFunctionId: number): boolean {
        if (!this.state.registerParamUseFunctionInfo) {
            return false
        }
        const registerParentUseFunctionInfo = this.state.registerParamUseFunctionInfo
            .find(registerUseFunction => registerUseFunction.functionId === functionId)
        if (!registerParentUseFunctionInfo) {
            return false
        }
        return registerParentUseFunctionInfo.childUseFunctionInfo.some(
            (registerChildUseFunction) => {
                return registerChildUseFunction.functionId === childFunctionId &&
                    registerChildUseFunction.validFlag === VALID_OR_NOT_CHECK.VALID.value
            })
    }

    renderAssocOfCondominium(): ReactNode {
        const {assocList} = this.state
        const selectAssocList: OptionProps[] = assocList
            .map((assoc) => {
                return {
                    label: `${assoc.assocCd}：${assoc.assocName}`,
                    value: assoc.uid
                }
            })

        const isAssocFunction: boolean =
            isFunctionAvailable(this.state.registerParamUseFunctionInfo, USE_FUNCTION_ID.ASSOC_DIRECTOR)
        const isApplyFunction: boolean = isApplyFunctionAvailable(this.state.registerParamUseFunctionInfo)

        return (<>
            <LeftRowFlexContainer>
                <NoWrappedAdminDefaultMediumButton onClick={this.handleClickAddAssoc}>
                    組合を追加
                </NoWrappedAdminDefaultMediumButton>
                <Box marginLeft={'20px'}>
                    <PPErrorLabel
                        eventEmitter={this.props.eventEmitter}
                        eventKeys={[`deleteAssoc`]}
                    />
                </Box>
            </LeftRowFlexContainer>
            {this.state.assocList.length > 0 &&
                <AssocListTable>
                    <LightGrayTableHead>
                        <TableRow>
                            <AssocCdTableCell>組合コード</AssocCdTableCell>
                            <AssocNameTableCell>組合名</AssocNameTableCell>
                            <TableCell width={'374px'}>上の管理組合を設定</TableCell>
                            <AssocOperationTableCell>操作</AssocOperationTableCell>
                        </TableRow>
                    </LightGrayTableHead>

                    <TableBody>
                        {this.state.assocList.map((condominiumAssoc, index) => {
                            const selectAssocListExcludingSelf = selectAssocList
                                .filter((assoc) => assoc.value !== condominiumAssoc.uid);

                            return (
                                <TableRow key={condominiumAssoc.uid}>
                                    <AssocCdTableCell>
                                        {condominiumAssoc.assocCd}
                                        <PPErrorLabel
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={[`assocList[${index}].assocCd`]}
                                        />
                                    </AssocCdTableCell>
                                    <AssocNameTableCell>
                                        {condominiumAssoc.assocName}
                                        <PPErrorLabel
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={[`assocList[${index}].assocName`]}
                                        />
                                    </AssocNameTableCell>
                                    <TableCell>
                                        <PPSelect
                                            name={condominiumAssoc.uid}
                                            data={addEmptyData(selectAssocListExcludingSelf, '管理組合を選択する')}
                                            onChange={this.onChangeParentAssoc}
                                            eventKeys={[`assocList[${index}].parentAssocName`]}
                                            eventEmitter={this.props.eventEmitter}
                                            value={
                                                this.state.assocList.find(
                                                    a => a.uid === condominiumAssoc.uid
                                                )?.parentAssocUid ?? ''
                                            }
                                            fullWidth
                                        />
                                    </TableCell>
                                    <AssocOperationTableCell>
                                        <OperationLinks>
                                            <EditLink onClick={this.handleClickEditAssoc(index)}>
                                                編集
                                            </EditLink>
                                            <DeleteLink onClick={this.assocListDeleteLinkClick(index)}>
                                                削除
                                            </DeleteLink>
                                        </OperationLinks>
                                    </AssocOperationTableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </AssocListTable>
            }

            {(isAssocFunction || isApplyFunction) &&
                <AssocUsingFunctionTable>
                    <TableBody>
                        {isAssocFunction &&
                            <TableRow>
                                <NoBorderTableCell width={'140px;'}>
                                    <LeftRowFlexContainer>
                                        理事会
                                        <Box ml={'27px'}><RequiredChip label={'必須'}/></Box>
                                    </LeftRowFlexContainer>
                                </NoBorderTableCell>
                                <NoBorderTableCell>
                                    <PPSelect
                                        data={addEmptyData(selectAssocList, '機能を利用する組合を選択してください')}
                                        onChange={this.onChangeAssocIdUsingAssocFunction}
                                        eventKeys={['assocCdUsingAssocFunction']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.assocIdUsingAssocFunction}
                                        fullWidth
                                    />
                                </NoBorderTableCell>
                            </TableRow>
                        }
                        {isApplyFunction &&
                            <TableRow>
                                <NoBorderTableCell width={'140px;'}>
                                    <LeftRowFlexContainer>
                                        申請
                                        <Box ml={'41px'}><RequiredChip label={'必須'}/></Box>
                                    </LeftRowFlexContainer>
                                </NoBorderTableCell>
                                <NoBorderTableCell>
                                    <PPSelect
                                        data={addEmptyData(selectAssocList, '機能を利用する組合を選択してください')}
                                        onChange={this.onChangeAssocIdUsingApplyFunction}
                                        eventKeys={['assocCdUsingApplyFunction']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.assocIdUsingApplyFunction}
                                        fullWidth
                                    />
                                </NoBorderTableCell>
                            </TableRow>
                        }
                    </TableBody>
                </AssocUsingFunctionTable>
            }
        </>)
    }

    renderInputFormTable(): ReactNode {
        return (
            <TableFixed>
                <colgroup>
                    <col width={'25%'}/>
                    <col width={'25%'}/>
                    <col width={'25%'}/>
                    <col width={'25%'}/>
                </colgroup>
                <StyledTableCaption>物件情報</StyledTableCaption>
                <TableBody>
                    {this.props.mode === 'register' ?
                        <TableRow>
                            <TableRowName required>物件グループを選択</TableRowName>
                            <TableCell colSpan={3}>
                                {
                                    this.state.condominiumGroup &&
                                    <NatCondominiumGroupSelectComponent
                                        condominiumGroup={this.state.condominiumGroup}
                                        defaultValue={this.state.registerParamCondominiumGroupId}
                                        onChangeSelectedCondominiumGroupId={this.onChangeSelectedCondominiumGroupId}
                                        requiredFlag={true}
                                        eventKeys={['condominiumGroupId']}
                                        eventEmitter={this.props.eventEmitter}
                                        autoFocus={true}
                                    >
                                    </NatCondominiumGroupSelectComponent>
                                }
                            </TableCell>
                        </TableRow>
                        :
                        <TableRow>
                            <TableRowName>物件グループ</TableRowName>
                            <TableCell colSpan={3}>{this.state.condominiumGroupName}</TableCell>
                        </TableRow>
                    }
                    {this.props.mode === 'register' ?
                        <TableRow>
                            <TableRowName required>物件コード</TableRowName>
                            <TableCell colSpan={3}>
                                <PPTextField
                                    InputProps={{
                                        inputProps: {
                                            maxLength: 6,
                                        },
                                    }}
                                    required
                                    hint={Messages.HCONA0001.toString()}
                                    value={this.state.registerParamCondominiumCd}
                                    onChange={this.onChangeCondominiumCd}
                                    eventKeys={['condominiumCd']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                        :
                        <TableRow>
                            <TableRowName>物件コード</TableRowName>
                            <TableCell colSpan={3}>{this.state.registerParamCondominiumCd}</TableCell>
                        </TableRow>
                    }
                    <TableRow>
                        <TableRowName required>物件名</TableRowName>
                        <TableCell colSpan={3}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                fullWidth
                                value={this.state.registerParamCondominiumName}
                                onChange={this.onChangeCondominiumName}
                                eventKeys={['condominiumName']}
                                eventEmitter={this.props.eventEmitter}
                                autoFocus={this.props.mode === 'edit'}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName
                            required={this.props.mode === 'edit'}
                            rowSpan={this.state.registerParamRidgeInfos.length + 1}
                        >
                            棟
                        </TableRowName>
                        <TableCell colSpan={3}>
                            <LeftRowFlexContainer>
                                <RidgeWrapper>
                                    <TableCellLabelNoLeftPadding>棟コード</TableCellLabelNoLeftPadding>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 2,
                                            },
                                        }}
                                        fullWidth
                                        value={this.state.registerParamRidgeCd}
                                        onChange={this.onChangeRidgeCd}
                                        eventKeys={['ridgeCd']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </RidgeWrapper>
                                <RidgeWrapper>
                                    <TableCellLabel>棟名</TableCellLabel>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 20,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        value={this.state.registerParamRidgeName}
                                        onChange={this.onChangeRidgeName}
                                        eventKeys={['condominiumRidgeName']}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </RidgeWrapper>
                                <RidgeWrapper>
                                    <AdminPrimaryButton
                                        onClick={() => this.addRidgeInfo(
                                            {
                                                ridgeCd: this.state.registerParamRidgeCd,
                                                ridgeName: this.state.registerParamRidgeName,
                                            })}
                                        disabled={!this.state.registerParamRidgeCd ||
                                            !this.state.registerParamRidgeName
                                        }
                                    >棟追加
                                    </AdminPrimaryButton>
                                </RidgeWrapper>
                            </LeftRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    {this.state.registerParamRidgeInfos.map((ridgeInfo, index) => (
                        <TableRow key={index}>
                            <TableCell colSpan={3}>
                                <LeftRowFlexContainer>
                                    <RidgeWrapper>
                                        <TableCellLabelNoLeftPadding>棟コード</TableCellLabelNoLeftPadding>
                                        <PPInput
                                            type="label"
                                            fullWidth
                                            value={ridgeInfo.ridgeCd}
                                            eventKeys={[`ridgeInfo[${index}].ridgeCd`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </RidgeWrapper>
                                    <RidgeWrapper>
                                        <TableCellLabel>棟名</TableCellLabel>
                                        <PPInput
                                            type="label"
                                            fullWidth
                                            value={ridgeInfo.ridgeName}
                                            eventKeys={[`ridgeInfo[${index}].ridgeName`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </RidgeWrapper>
                                    <RidgeWrapper>
                                        <DeleteRidgeLink>
                                            <DeleteLink onClick={() => this.delRidgeInfo(index)}>
                                                削除
                                            </DeleteLink>
                                        </DeleteRidgeLink>
                                    </RidgeWrapper>
                                </LeftRowFlexContainer>
                            </TableCell>
                        </TableRow>
                    ))
                    }
                    <TableRow>
                        <TableRowName>画像</TableRowName>
                        <TableCell colSpan={3}>
                            <PPImageInputWithPreview
                                images={this.state.selectedImagesInfo}
                                maxCount={1}
                                maxFileSizeBytesPerFile={5 * 1024 * 1024}
                                maxFileSizeBytesPerFileMessage={
                                    'アップロードファイルの上限サイズは1ファイルあたり5MBまでです'
                                }
                                helperText={<div>5MBまで</div>}
                                onChange={this.handleImagesChange}
                                eventKeys={['condominiumFileData']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>郵便番号</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 7,
                                    },
                                }}
                                fullWidth
                                value={this.state.registerParamZipcode}
                                onChange={this.onChangeZipCd}
                                eventKeys={['zipcode']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                        <TableCell colSpan={3}>
                            <AdminPrimaryButton
                                onClick={() => this.getAddressFromZipcode(this.state.registerParamZipcode)}
                            >郵便番号から住所入力
                            </AdminPrimaryButton>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>都道府県</TableRowName>
                        <TableCell colSpan={3}>
                            <PPSelect
                                data={addEmptyData(PREFECTURES_MASTER.values(), '都道府県を選択してください')}
                                onChange={this.onChangePrefectureCd}
                                eventKeys={['prefectureCd']}
                                eventEmitter={this.props.eventEmitter}
                                value={this.state.registerParamPrefectureCd}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>市区町村</TableRowName>
                        <TableCell colSpan={3}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.registerParamAddress2}
                                onChange={this.onChangeAddress2}
                                eventKeys={['address2']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>番地</TableRowName>
                        <TableCell colSpan={3}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                fullWidth
                                value={this.state.registerParamAddress3}
                                onChange={this.onChangeAddress3}
                                eventKeys={['address3']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>連絡先メールアドレス1</TableRowName>
                        <TableCell colSpan={3}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 100,
                                    },
                                }}
                                fullWidth
                                onChange={this.onChangeContactMailAddress(1)}
                                eventKeys={[`condominiumContactInfo[0].mailAddress`]}
                                eventEmitter={this.props.eventEmitter}
                                value={this.state.registerParamContactMailAddress1}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>連絡先メールアドレス2</TableRowName>
                        <TableCell colSpan={3}>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 100,
                                    },
                                }}
                                fullWidth
                                onChange={this.onChangeContactMailAddress(2)}
                                eventKeys={[`condominiumContactInfo[1].mailAddress`]}
                                eventEmitter={this.props.eventEmitter}
                                value={this.state.registerParamContactMailAddress2}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>事務センター対応</TableRowName>
                        <TableCell colSpan={3}>
                            <PPRadioGroup
                                row
                                data={TARGET_OR_NOT.values()}
                                value={this.state.registerParamBusinessCenterSupport}
                                onChange={this.onChangeBusinessCenterSupport}
                                eventKeys={['businessCenterSupport']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>入退室管理</TableRowName>
                        <TableCell colSpan={3}>
                            <LeftRowFlexContainer>
                                {ACCESS_CONTROL_MANAGER.values().map((accessControlManager) =>
                                    <AccessControlManagerArea key={accessControlManager.value}>
                                        <PPCheckboxGroup
                                            data={[{
                                                label: accessControlManager.label,
                                                checked: this.state.registerParamAccessControlManagerList
                                                    .includes(accessControlManager.value),
                                            }]}
                                            onChangeChecked={this.onChangeAccessControlManager}
                                        />
                                    </AccessControlManagerArea>)
                                }
                            </LeftRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>機能一覧
                            <HintButton message={Messages.HCONA0003.toString()}/>
                        </TableRowName>
                        <TableCell colSpan={3}>
                            <TableFixed>
                                <colgroup>
                                    <col width={'8.5%'}/>
                                    <col width={'25%'}/>
                                    <col width={'25%'}/>
                                    <col width={'25%'}/>
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <MenuTableHeadCell colSpan={2} key={'menuName'}>機能名</MenuTableHeadCell>
                                        <MenuTableHeadCell key={'menuDescription'}>機能説明</MenuTableHeadCell>
                                        <MenuTableHeadCell key={'valid'}>有効</MenuTableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.useFunctionMaster.map((useFunctionInfo, index) => (
                                        <React.Fragment key={index}>
                                            <TableRow>
                                                <TableCell colSpan={2}>
                                                    {useFunctionInfo.useFunctionInfo.useFunctionName}
                                                </TableCell>
                                                <TableCell>
                                                    {useFunctionInfo.useFunctionInfo.useFunctionDescription}
                                                </TableCell>
                                                <ValidTableCell>
                                                    {useFunctionInfo.childUseFunctionInfo.length === 0 ?
                                                        <PPCheckboxGroup
                                                            data={[{
                                                                label: '',
                                                                checked: this.judgeUseFunctionValidFlag(
                                                                    useFunctionInfo.useFunctionInfo.functionId
                                                                ),
                                                            }]}
                                                            onChange={
                                                                () => this.onChangeValidFlag(
                                                                    useFunctionInfo.useFunctionInfo.functionId
                                                                )
                                                            }
                                                        /> :
                                                        <></>
                                                    }
                                                </ValidTableCell>
                                            </TableRow>
                                            {useFunctionInfo.childUseFunctionInfo.map((childUseFunction, childIndex) =>
                                                <TableRow key={childUseFunction.functionId}>
                                                    {childIndex === 0 &&
                                                        <NoBorderTableCell
                                                            rowSpan={useFunctionInfo.childUseFunctionInfo.length}/>
                                                    }
                                                    <TableCell>{childUseFunction.useFunctionName}</TableCell>
                                                    <TableCell>{childUseFunction.useFunctionDescription}</TableCell>
                                                    <ValidTableCell>
                                                        <PPCheckboxGroup
                                                            data={[{
                                                                label: '',
                                                                checked: this.judgeChildFunctionValidFlag(
                                                                    useFunctionInfo.useFunctionInfo.functionId,
                                                                    childUseFunction.functionId
                                                                )
                                                            }]}
                                                            onChange={
                                                                () => this.onChangeChildValidFlag(
                                                                    useFunctionInfo.useFunctionInfo.functionId,
                                                                    childUseFunction.functionId
                                                                )
                                                            }
                                                        />
                                                    </ValidTableCell>
                                                </TableRow>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </TableFixed>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>管理組合</TableRowName>
                        <TableCell colSpan={3}>
                            {this.renderAssocOfCondominium()}
                        </TableCell>
                        {this.renderAssocDialog()}
                    </TableRow>
                    <TableRow>
                        <TableRowName required>抽選予約</TableRowName>
                        <TableCell colSpan={3}>
                            <PPRadioGroup
                                row
                                data={HAVE_OR_NOT.values()}
                                value={this.state.registerParamLotteryReserve}
                                onChange={this.onChangeLotteryReserve}
                                eventKeys={['lotteryReserve']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    {this.state.registerParamLotteryReserve === HAVE_OR_NOT.HAVE.value &&
                        <>
                            <TableRow>
                                <TableRowName required>施設予約抽選期間</TableRowName>

                                <TableCell colSpan={3}>
                                    <LeftRowFlexContainer>
                                        {/*【仕様変更】施設予約抽選期間の開始をラベルで1固定に変更 MOD-START*/}
                                        {/*<PPSelect*/}
                                        {/*    fullWidth*/}
                                        {/*    data={addEmptyData(
                                        FACILITY_RESERVATION_DRAWING_START_DATE.values(), '抽選開始日を選択してください')}*/}
                                        {/*    defaultValue={this.state.registerParamFacilityReserveLotteryStart}*/}
                                        {/*    onChange={this.onChangeFacilityReserveLotteryStart}*/}
                                        {/*    eventKeys={['facilityReserveLotteryStart']}*/}
                                        {/*    eventEmitter={this.props.eventEmitter}*/}
                                        {/*/>*/}
                                        {/*<TableCellLabel>日から</TableCellLabel>*/}
                                        <TableCellLabel>
                                            {this.state.registerParamFacilityReserveLotteryStart}日から</TableCellLabel>
                                        {/*【仕様変更】施設予約抽選期間の開始をラベルで1固定に変更 MOD-END*/}
                                        <PPSelect
                                            fullWidth
                                            data={
                                                addEmptyData(FACILITY_RESERVATION_DRAWING_END_DATE.values(), '抽選終了日を選択してください')
                                            }
                                            value={this.state.registerParamFacilityReserveLotteryEnd}
                                            onChange={this.onChangeFacilityReserveLotteryEnd}
                                            eventKeys={['facilityReserveLotteryEnd']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        <TableCellLabel>日</TableCellLabel>
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>

                            <TableRow>
                                <TableRowName>施設予約確定期日</TableRowName>
                                <TableCell colSpan={3}>
                                    <LeftRowFlexContainer>
                                        <PPSelect
                                            fullWidth
                                            data={addEmptyData(FACILITY_RESERVATION_CONFIRMED_DATE.values(), '確定日なし')}
                                            value={this.state.registerParamFacilityReserveConfirmLimit}
                                            onChange={this.onChangeFacilityReserveConfirmLimit}
                                            eventKeys={['facilityReserveConfirmLimit']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        <TableCellLabel>日</TableCellLabel>
                                        <HintButton message={Messages.HCONA0004.toString()}/>
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>施設予約抽選対象月</TableRowName>
                                <TableCell colSpan={3}>
                                    <LeftRowFlexContainer>
                                        <PPNumericField
                                            InputProps={{
                                                inputProps: {
                                                    min: 1,
                                                    max: 5,
                                                },
                                            }}
                                            value={this.state.registerParamFacilityReserveLotteryMonth}
                                            onChange={this.onChangeFacilityReserveLotteryMonth}
                                            eventKeys={['facilityReserveLotteryMonth']}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                        <TableCellLabel>ヶ月後</TableCellLabel>
                                        <HintButton message={Messages.HCONA0005.toString()}/>
                                    </LeftRowFlexContainer>
                                </TableCell>
                            </TableRow>
                        </>
                    }
                    {
                        isReserveFacilityAvailable(this.state.registerParamUseFunctionInfo) &&
                        <TableRow>
                            <TableRowName required>日またぎの予約回数の数え方</TableRowName>
                            <TableCell colSpan={3}>
                                <PPRadioGroup
                                    row
                                    data={DATE_STRADDLE_RESERVATION_COUNTING_METHOD.values()}
                                    value={this.state.registerParamDateStraddleReservationCountingMethod}
                                    onChange={this.onChangeDateStraddleReservationCountingMethod}
                                    hint={'日またぎの予約回数の数え方を設定します。\nこの設定は、時間貸し施設における１日あたりの最大予約回数に適用されます。\n・１予約につき１回：予約開始日に予約１回を計上します。\n・１日につき１回：予約に含まれるすべての日にそれぞれ予約１回を計上します。'}
                                    eventKeys={['dateStraddleReservationCountingMethod']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </TableCell>
                        </TableRow>
                    }
                    {
                        isAccountTransferAvailable(this.state.registerParamUseFunctionInfo) && <>
                            <TableRow>
                                <TableRowName required>担当組合会計部</TableRowName>
                                <TableCell>
                                    <PPSelect
                                        data={addEmptyData(ASSOC_ACCOUNTING_DEPT_CD.values(), '')}
                                        onChange={this.onChangeAssocAccountingDeptCd}
                                        eventKeys={['assocAccountingDeptCd']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.registerParamAssocAccountingDeptCd}
                                    />
                                </TableCell>
                                <TableRowName required>収納代行会社</TableRowName>
                                <TableCell>
                                    <PPSelect
                                        data={addEmptyData(RECEIVING_AGENCY_CD.values(), '')}
                                        onChange={this.onChangeReceivingAgencyCd}
                                        eventKeys={['receivingAgencyCd']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.registerParamReceivingAgencyCd}
                                    />
                                </TableCell>
                            </TableRow>
                        </>
                    }
                    <TableRow>
                        <TableRowName required>請求締め日</TableRowName>
                        <TableCell colSpan={3}>
                            <LeftRowFlexContainer>
                                <PPSelect
                                    fullWidth
                                    data={BILLING_DEADLINE.values()}
                                    value={this.state.registerParamBillingDeadline}
                                    onChange={this.onChangeBillingDeadline}
                                    eventKeys={['billingDeadline']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <TableCellLabel>日</TableCellLabel>
                            </LeftRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>掲示板ユーザー表示</TableRowName>
                        <TableCell colSpan={3}>
                            <PPSelect
                                fullWidth
                                data={addEmptyData(USER_DISPLAY_ITEMS.values(), '')}
                                value={this.state.registerParamBoardUserDisplay}
                                onChange={this.onChangeBoardUserDisplay}
                                eventKeys={['boardUserDisplay']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>公開開始日</TableRowName>
                        <TableCell style={{paddingBottom: 18, paddingTop: 22}}>
                            <PPDatePicker
                                onChangeDate={this.onChangeReleaseStartDate}
                                value={(this.state.registerParamReleaseStartDate) ?
                                    new Date(this.state.registerParamReleaseStartDate) : null
                                }
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={['releaseStartDate']}
                                maxDate={(this.state.registerParamReleaseEndDate) ?
                                    new Date(this.state.registerParamReleaseEndDate) : undefined
                                }
                            />
                        </TableCell>
                        <TableRowName>公開終了日</TableRowName>
                        <TableCell style={{paddingBottom: 18, paddingTop: 22}}>
                            <PPDatePicker
                                onChangeDate={this.onChangeReleaseEndDate}
                                value={(this.state.registerParamReleaseEndDate) ?
                                    new Date(this.state.registerParamReleaseEndDate) : null
                                }
                                eventEmitter={this.props.eventEmitter}
                                eventKeys={['releaseEndDate']}
                                minDate={(this.state.registerParamReleaseStartDate) ?
                                    new Date(this.state.registerParamReleaseStartDate) : undefined
                                }
                            />
                        </TableCell>
                    </TableRow>
                </TableBody>
            </TableFixed>
        )
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeRegisterButtonDisabled()}
                        onClick={this.onClickRegisterButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.props.onBack}
                    >
                        {this.props.backButtonText}
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderAssocDialog(): ReactNode {
        const {
            showAssocDialog,
            assocDialogMode,
        } = this.state

        return (
            <StyledDialog
                open={showAssocDialog}
                maxWidth={'md'}
            >
                <StyledDialogTitle>
                    <AdminPageHeadingArea
                        title={assocDialogMode === 'register' ? '組合追加' : '組合編集'}
                    />
                </StyledDialogTitle>
                <StyledDialogContent>
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableRowName required>組合コード</TableRowName>
                                <TableCell>
                                    <StyledInput
                                        type="text"
                                        inputProps={{
                                            minLength: 0,
                                            maxLength: 2,
                                        }}
                                        value={this.state.assocDialogAssocCd}
                                        onChange={this.onChangeAssocCd}
                                    />
                                    {this.state.condominiumAssocCdErrorMessage &&
                                        <ErrorMessage>
                                            {this.state.condominiumAssocCdErrorMessage}
                                        </ErrorMessage>
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TableRowName required>組合名</TableRowName>
                                <TableCell>
                                    <PPInput
                                        type="text"
                                        inputProps={{
                                            minLength: 0,
                                            maxLength: 100,
                                        }}
                                        value={this.state.assocDialogAssocName}
                                        onChange={this.onChangeAssocName}
                                        fullWidth
                                    />
                                    {this.state.condominiumAssocNameErrorMessage &&
                                        <ErrorMessage>
                                            {this.state.condominiumAssocNameErrorMessage}
                                        </ErrorMessage>
                                    }
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                    <PageFooterArea>
                        <PageFotterAreaRight>
                            <AdminPrimaryButton
                                disabled={
                                    this.state.assocDialogAssocCd.length === 0
                                    || this.state.assocDialogAssocName.length === 0
                                }
                                onClick={this.handleClickAssocDialogResisterButton}
                            >
                                登録する
                            </AdminPrimaryButton>
                        </PageFotterAreaRight>
                        <PageFotterAreaLeft>
                            <BackLink onClick={this.handleClickAssocDialogCancelButton}>キャンセル</BackLink>
                        </PageFotterAreaLeft>
                    </PageFooterArea>
                </StyledDialogContent>
            </StyledDialog>
        )
    }

    render(): ReactElement {
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderInputFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>
        )
    }
}

export function judgeRegisterButtonDisabledFunction(
    mode: 'register' | 'edit',
    condominiumGroupId: number | null,
    condominiumCd: string,
    condominiumName: string,
    ridgeInfos: RidgeInfo[],
    zipcode: string,
    prefectureCd: string,
    address2: string,
    businessCenterSupport: string,
    useFunctionInfo: UseFunctionInfo[],
    assocList: CondominiumAssoc[],
    assocIdUsingAssocFunction: string,
    assocIdUsingApplyFunction: string,
    lotteryReserve: string,
    facilityReserveLotteryStart: string,
    facilityReserveLotteryEnd: string,
    facilityReserveLotteryMonth: number | null,
    dateStraddleReservationCountingMethod: string,
    boardUserDisplay: string,
    assocAccountingDeptCd: string,
    receivingAgencyCd: string,
    billingDeadline: string,
): boolean {
    if (!condominiumGroupId ||
        !condominiumCd ||
        !condominiumName ||
        !zipcode ||
        !prefectureCd ||
        !address2 ||
        !businessCenterSupport ||
        !lotteryReserve ||
        !dateStraddleReservationCountingMethod ||
        !boardUserDisplay ||
        !billingDeadline
    ) {
        return true
    }
    if (mode === 'edit') {
        if (ridgeInfos.length === 0) {
            return true
        }
    }
    if (assocList.length === 0) {
        return true
    }

    if (isFunctionAvailable(useFunctionInfo, USE_FUNCTION_ID.ASSOC_DIRECTOR)) {
        if (assocIdUsingAssocFunction === '') {
            return true
        }
    }

    if (isApplyFunctionAvailable(useFunctionInfo)) {
        if (assocIdUsingApplyFunction === '') {
            return true
        }
    }

    if (lotteryReserve === HAVE_OR_NOT.HAVE.value) {
        if (!facilityReserveLotteryStart ||
            !facilityReserveLotteryEnd ||
            !facilityReserveLotteryMonth
        ) {
            return true
        }
    }
    if (isAccountTransferAvailable(useFunctionInfo)) {
        if (!assocAccountingDeptCd || !receivingAgencyCd) {
            return true
        }
    }
    return false
}


function isFunctionAvailable(
    useFunctions: UseFunctionInfo[] | ChildUseFunctionInfo[],
    useFunctionId: USE_FUNCTION_ID
): boolean {
    return useFunctions.some(functionInfo => {
        return functionInfo.functionId === Number(useFunctionId.value)
            && functionInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value
    })
}

function isReserveFacilityAvailable(useFunctions: UseFunctionInfo[]): boolean {
    return isFunctionAvailable(useFunctions, USE_FUNCTION_ID.FACILITY)
}

function isAccountTransferAvailable(useFunctions: UseFunctionInfo[]): boolean {
    const childUseFunctions = useFunctions.find(info =>
        info.functionId === Number(USE_FUNCTION_ID.ACCOUNT_TRANSFER.value))?.childUseFunctionInfo
    if (!childUseFunctions) {
        return false
    }
    return isFunctionAvailable(childUseFunctions, USE_FUNCTION_ID.WEB_ACCOUNT_TRANSFER)
}

function isApplyFunctionAvailable(useFunctions: UseFunctionInfo[]): boolean {
    const childUseFunctionInfos = useFunctions.find(functionInfo =>
        functionInfo.functionId === Number(USE_FUNCTION_ID.APPLICATION.value))
    if (childUseFunctionInfos === undefined) {
        return false
    }
    if (childUseFunctionInfos.childUseFunctionInfo === undefined) {
        return false
    }
    return childUseFunctionInfos.childUseFunctionInfo.some(functionInfo => {
        return functionInfo.validFlag === VALID_OR_NOT_CHECK.VALID.value
    })
}

const TableCellLabel: StyledLabel = styled.label`
  padding: 0 10px;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`


const MenuTableHeadCell = styled(TableCell)`
  &.MuiTableCell-root {
    text-align: center;
    font-weight: bold;
    font-size: inherit;
  }
`

const NoBorderTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    border-bottom: 0 solid;
  }
`

const ValidTableCell = styled(TableCell)`
  [class*=MuiFormControlLabel-root] {
    margin: auto;
  }

  [class*=FlexComponents] {
    justify-content: center;
  }
`

const DeleteRidgeLink = styled.div`
  margin-right: 60px;
`

const RidgeWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const StyledDialog = withStyles({
    paper: {
        width: '840px',
        padding: '24px',
    },
})(AdminDialog)

const StyledDialogTitle = styled(DialogTitle)`
  padding: 0;
`

const StyledDialogContent = styled(DialogContent)`
  padding: 0;
`

const StyledInput = styled(PPInput)`
  width: 48px;
`

const ErrorMessage = styled.div`
  margin-top: 4px;
  font-size: ${FontSizeInPixel.Small}px;
  color: ${Colors.Alert};
`

const NoWrappedAdminDefaultMediumButton = styled(AdminDefaultMediumButton)`
  white-space: nowrap;
  min-width: 102px;
`

const AssocListTable = styled(Table)`
  &.MuiTable-root {
    margin-top: 24px;
    width: 100%;
  }

  .MuiTableHead-root .MuiTableCell-root {
    padding: 8px 16px;
  }

  .MuiTableCell-root {
    padding: 16px;
  }
`

const AssocUsingFunctionTable = styled(Table)`
  margin-top: 24px;
  width: 724px;
`

const OperationLinks = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 20px;
`

const AccessControlManagerArea = styled.div`
  &:not(:last-child) {
    margin-right: 15px;
  }
`

const AssocCdTableCell = styled(TableCell)`
  width: 102px;
  min-width: 102px;
`

const AssocNameTableCell = styled(TableCell)`
  width: 374px;
  overflow-wrap: anywhere;
`

const AssocOperationTableCell = styled(TableCell)`
  width: 156px;
  min-width: 156px;
`
